import { __assign, __makeTemplateObject, __rest } from "tslib";
import React, { forwardRef, useMemo } from 'react';
import MuiDialogActions from '@material-ui/core/DialogActions';
import { combineClasses, styled, useThemeProps, } from '../../../foundation';
import { useDialogDefaultProps } from '../utils';
import { DialogActionsStyle } from './styles';
import { RcDialogActionsClasses } from './utils';
var _RcDialogActions = forwardRef(function (inProps, ref) {
    var props = useThemeProps({ props: inProps, name: 'RcDialogActions' });
    var classesProp = props.classes, size = props.size, children = props.children, reverse = props.reverse, rest = __rest(props, ["classes", "size", "children", "reverse"]);
    var classes = useMemo(function () { return combineClasses(RcDialogActionsClasses, classesProp); }, [classesProp]);
    return (React.createElement(MuiDialogActions, __assign({}, rest, { ref: ref, classes: classes, disableSpacing: true }), children));
});
var RcDialogActions = styled(_RcDialogActions).attrs(function (props) {
    var _a, _b;
    var toProps = useDialogDefaultProps(props);
    var direction = (_a = toProps.direction) !== null && _a !== void 0 ? _a : (toProps.size === 'small' ? 'vertical' : 'horizontal');
    var reverse = (_b = toProps.reverse) !== null && _b !== void 0 ? _b : direction === 'vertical';
    return __assign(__assign({}, toProps), { direction: direction,
        reverse: reverse });
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), DialogActionsStyle);
RcDialogActions.defaultProps = {};
RcDialogActions.displayName = 'RcDialogActions';
export { RcDialogActions };
var templateObject_1;
